import { arrow, offset, shift, useFloating } from "@floating-ui/react-dom";
import { composeRefHandlers } from "@utils/general";
import React, { CSSProperties, useRef } from "react";
import { useTheme } from "styled-components";

import useHideOnBlur from "../../hooks/HideOnBlurHook";
import { TooltipArrow } from "../tooltipIcon/TooltipIcon.styles";
import BackgroundJobsPopup, { IBackgroundJobsProps } from "./BackgroundJobsPopup";
import ProgressBanner, { IProgressBannerProps } from "./ProgressBanner";
import { BannerPopperWrapper } from "./ProgressBanner.styles";

interface IProps {
    bannerProps: IProgressBannerProps;
    popupProps: IBackgroundJobsProps;
    isOpen?: boolean;
    onClose?: () => void;
    className?: string;
}

const ProgressBannerWithBackgroundJobsPopup = React.memo<IProps>((props) => {
    const arrowRef = useRef(null);

    const { refs, floatingStyles, middlewareData, placement } = useFloating({
        placement: "bottom-start",
        middleware: [
            offset({ crossAxis: 0, mainAxis: 8 }),
            shift({ padding: 19, rootBoundary: "viewport" }),
            arrow({ element: arrowRef }),
        ]
    });

    const arrowStyle: CSSProperties = {
        left: middlewareData.arrow?.x != null ? `${middlewareData.arrow.x}px` : '',
        top: middlewareData.arrow?.y != null ? `${middlewareData.arrow.y}px` : '',
    };


    const theme = useTheme();
    const popupRef = useRef(null);
    const _ = useHideOnBlur({
        refs: [popupRef, arrowRef],
        isVisible: props.isOpen,
        onHide: props.onClose
    });

    return (
        <>
            <ProgressBanner {...props.bannerProps}
                            isActive={props.isOpen}
                            passRef={refs.setReference}
                            className={props.className}/>
            {props.isOpen &&
                    <BannerPopperWrapper ref={refs.setFloating}
                                         style={floatingStyles}
                                         data-popper-placement={placement}>
                    <BackgroundJobsPopup {...props.popupProps}
                                         passRef={composeRefHandlers(popupRef, props.popupProps?.passRef)}/>
                        <TooltipArrow ref={arrowRef}
                        // for HideOnBlur to work
                                  tabIndex={-1}
                                      style={arrowStyle}
                                  color={theme.C_BG_menu}
                                      data-popper-placement={placement}/>
                </BannerPopperWrapper>
            }
        </>
    );
});

export default ProgressBannerWithBackgroundJobsPopup;